/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import React from "react";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

const RoundButton = ({ children, sx = {}, ...props }) => (
  <Button
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    sx={{
      width: 40,
      height: 40,
      minWidth: "auto",
      borderRadius: "50%",
      padding: 0,
      ...sx
    }}
  >
    {children}
  </Button>
);

RoundButton.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object
};

RoundButton.defaultProps = {
  sx: {}
};

export default RoundButton;
